/* LbxRide theme — catalog, product view and cart.
   Products, prices, stock and photos come live from Shopify (/products.json).
   Bike fitment + category live in assets/fitment.json; review counts in assets/reviews.json. */
(function () {
'use strict';

var T = window.LBX || {};
var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var $ = function (id) { return document.getElementById(id); };
var esc = function (t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
var money = function (cents) {
  var v = (cents / 100);
  var s = v.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '$' + s;
};

var BIKES = [
  { id: 'lbx', label: 'Sur-Ron LBX' }, { id: 'ub', label: 'Sur-Ron Ultra Bee' }, { id: 'txxx', label: 'Talaria XXX' },
  { id: 'tmx34', label: 'Talaria MX3 / MX4 / Sting' }, { id: 'tmx5', label: 'Talaria MX5' }, { id: 'tx3', label: 'Talaria X3 / X3 Pro' },
  { id: 'eride', label: 'E-Ride Pro' }, { id: 'segway', label: 'Segway X160 / X260' }, { id: 'yozma', label: 'Yozma IN10' },
  { id: 'mini', label: 'Tuttio / Heybike / Razor' }, { id: 'strike', label: 'Strike / Shadow / Cemoto' },
  { id: 's73', label: 'Super73 / Ridstar / MacFox' }, { id: 'rtr', label: 'ETM RTR' }, { id: 'f79', label: '79Bike Falcon' },
  { id: 'stark', label: 'Stark Varg' }, { id: 'vetra', label: 'Vetra / Arctic Leopard' }, { id: 'altis', label: 'Altis Sigma' }
];
var CATS = [
  { id: 'brakes', label: 'Brakes' }, { id: 'wheels', label: 'Wheels & tires' }, { id: 'ti', label: 'Titanium & bolts' },
  { id: 'carbon', label: 'Carbon' }, { id: 'frames', label: 'Frames' }, { id: 'lights', label: 'Lights' },
  { id: 'body', label: 'Guards & body' }, { id: 'seats', label: 'Seats' }, { id: 'wraps', label: 'Wraps & plates' },
  { id: 'power', label: 'Suspension & power' }, { id: 'controls', label: 'Controls & pegs' },
  { id: 'bikes', label: 'Complete bikes' }, { id: 'merch', label: 'Merch' }
];
/* order the catalog uses once a bike is picked */
var GROUPS = [
  ['brakes', 'Brakes'], ['wfull', 'Wheel sets with tires'], ['wrim', 'Rim sets — no tires'], ['ti', 'Titanium bolts'],
  ['lights', 'Lights'], ['susp', 'Suspension'], ['body', 'Guards & body'], ['carbon', 'Carbon'], ['seats', 'Seats'],
  ['controls', 'Controls & pegs'], ['power', 'Motors & drivetrain'], ['wraps', 'Wraps & plates'], ['frames', 'Frames'],
  ['bikes', 'Complete bikes'], ['merch', 'Merch']
];
var GIDX = {}; GROUPS.forEach(function (g, i) { GIDX[g[0]] = i; });
var bikeName = function (id) { for (var i = 0; i < BIKES.length; i++) if (BIKES[i].id === id) return BIKES[i].label; return id; };
var catName = function (id) { for (var i = 0; i < CATS.length; i++) if (CATS[i].id === id) return CATS[i].label; return id; };

/* ---------- fitment + category for products the data file doesn't cover ---------- */
var BIKE_RX = [
  ['lbx', /\blbx\b|light ?bee|lightbee/], ['txxx', /\bxxx\b/], ['tmx34', /\bmx ?3\b|\bmx ?4\b|sting/], ['tmx5', /\bmx ?5\b/],
  ['tx3', /\bx3\b/], ['eride', /e[- ]?ride/], ['segway', /segway|x160|x260/], ['yozma', /yozma/], ['f79', /79 ?bike|\bfalcon\b/],
  ['s73', /super ?73|ridstar|mac ?fox/], ['mini', /tuttio|heybike|razor|valintsu|valtinsu/], ['strike', /\bstrike\b|\bshadow\b|cemoto/],
  ['stark', /stark varg/], ['vetra', /vetra|arctic leopard/], ['rtr', /\brtr\b|\betm\b/], ['altis', /altis/]
];
function guessCat(title) {
  var s = title.toLowerCase();
  if (/electric (dirt )?bike/.test(s)) return 'bikes';
  if (/hoodie|t shirt|t-shirt|popsocket|pop socket|sticker/.test(s)) return 'merch';
  if (/carbon/.test(s)) return 'carbon';
  if (/plates?\b/.test(s) && !/skid|bolt/.test(s)) return 'wraps';
  if (/sprocket|chain/.test(s) && !/bolt/.test(s)) return 'power';
  if (/\bbolts?\b|\bnuts?\b/.test(s)) return 'ti';
  if (/\bpegs?\b|peg kit|peg mount/.test(s)) return 'controls';
  if (/titanium/.test(s)) return 'ti';
  if (/brake|caliper|footbrake/.test(s)) return 'brakes';
  if (/wheel|supermoto|sumos/.test(s)) return 'wheels';
  if (/powder coated frame|frame set/.test(s)) return 'frames';
  if (/rock ?light|baja|\bbeam\b|tint/.test(s)) return 'lights';
  if (/seat/.test(s)) return 'seats';
  if (/wrap|decal|graphics|vinyl/.test(s)) return 'wraps';
  if (/guard|shield|fender|cover|panel/.test(s)) return 'body';
  if (/fork|shock|triple clamp|motor|controller|charger/.test(s)) return 'power';
  return 'controls';
}
function guessBikes(title) {
  var s = title.toLowerCase(), out = [];
  BIKE_RX.forEach(function (r) { if (r[1].test(s)) out.push(r[0]); });
  if (/ultra ?bee/.test(s) && !out.length) out.push('ub');
  return out;
}

/* ---------- state ---------- */
var P = [], byHandle = {}, FIT = {}, REV = { store: { avg: 0, n: 0 }, products: {}, feed: [] };
var sel = null, fcats = {}, only = { stock: false, sale: false, hot: false, uni: true }, sortBy = 'feat', query = '';
var PAGE = 24, shown = 0, current = [], lastG = null, gCount = {};
var cart = { items: [], item_count: 0, total_price: 0 };

var fcount = function () { var n = 0; for (var k in fcats) if (fcats[k]) n++; return n; };
var groupOf = function (p) { return p.cat === 'wheels' ? (p.rim ? 'wrim' : 'wfull') : p.cat === 'power' ? (p.susp ? 'susp' : 'power') : p.cat; };
var grouped = function () { return !!sel && sortBy === 'feat'; };
var starSpan = function (v, label) {
  return '<span class="stars" style="--pct:' + (v / 5 * 100) + '%"' + (label ? ' role="img" aria-label="' + v + ' out of 5 stars"' : ' aria-hidden="true"') + '></span>';
};
var fmtDate = function (d) { return d ? new Date(d.slice(0, 10) + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''; };
var imgUrl = function (src, w) { return src ? src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$3') : ''; };

/* "Ships next day" is claimed in the product copy, not only the title — read both. */
var SHIP_TITLE = /ships next|24 ?hour/i;
var SHIP_BODY = /ships?(\s+\w+){0,3}\s+next\s+(business\s+)?day|next\s+business\s+day|24\s*-?\s*hour\s*ship/i;
function shipsFast(raw) {
  if (SHIP_TITLE.test(raw.title || '')) return true;
  var plain = (raw.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ');
  return SHIP_BODY.test(plain);
}

/* ---------- load ---------- */
function decorate(raw) {
  var f = FIT[raw.handle] || {};
  var prices = raw.variants.map(function (v) { return Math.round(parseFloat(v.price) * 100); });
  var cmps = raw.variants.map(function (v) { return v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0; });
  var mi = prices.indexOf(Math.min.apply(null, prices));
  var title = (raw.title || '').replace(/\s*\((ships next (business )?day|pre-?order|pree order|no tires?|no tire)\)/ig, '').replace(/\s+/g, ' ').trim();
  return {
    id: raw.id, h: raw.handle, n: title, raw: raw,
    cat: f.c || guessCat(raw.title), b: f.b || guessBikes(raw.title),
    rim: f.rim || /no tires?/i.test(raw.title) ? 1 : 0, susp: f.susp || 0, hot: f.hot || 0,
    p: prices[mi], was: cmps[mi] > prices[mi] ? cmps[mi] : 0,
    vary: prices.filter(function (v, i, a) { return a.indexOf(v) === i; }).length > 1,
    out: !raw.variants.some(function (v) { return v.available; }),
    pre: /pre-?order|pree order/i.test(raw.title),
    ship: shipsFast(raw) ? 1 : 0,
    images: raw.images.map(function (im) { return { src: im.src, w: im.width, h: im.height }; }),
    variants: raw.variants, options: raw.options, body: raw.body_html || ''
  };
}
/* Live per-product Judge.me ratings, rendered by templates/collection.ratings.liquid.
   Resolves {} when the feed is missing so the reviews.json snapshot is used instead. */
function loadLiveRatings() {
  var get = function (n) {
    return fetch(ROOT + 'collections/all?view=ratings&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
      .catch(function () { return null; });
  };
  return get(1).then(function (first) {
    if (!first || !first.products) return {};
    var out = first.products, more = [];
    for (var n = 2; n <= Math.min(first.pages || 1, 6); n++) more.push(get(n));
    return Promise.all(more).then(function (rest) {
      rest.forEach(function (x) { if (x && x.products) for (var h in x.products) out[h] = x.products[h]; });
      return out;
    });
  });
}
function mergeLive(live) {
  var hs = Object.keys(live || {});
  if (hs.length) {                       // live data wins; keep snapshot quotes as samples
    var prods = {};
    hs.forEach(function (h) {
      var old = REV.products[h];
      prods[h] = { avg: +live[h].avg, n: +live[h].n, list: old && old.list ? old.list : [] };
    });
    REV.products = prods;
  }
  if (T.store && T.store.live) REV.store = { avg: +T.store.avg, n: +T.store.n };
  else if (hs.length) {                  // no shop metafield: total up the live product counts
    var n = 0, sum = 0;
    hs.forEach(function (h) { n += REV.products[h].n; sum += REV.products[h].avg * REV.products[h].n; });
    if (n > REV.store.n) REV.store = { avg: Math.round(sum / n * 100) / 100, n: n };
  }
}
function load() {
  var pages = [ROOT + 'products.json?limit=250&page=1', ROOT + 'products.json?limit=250&page=2'];
  return Promise.all([
    fetch(T.fitmentUrl).then(function (r) { return r.json(); }).catch(function () { return {}; }),
    fetch(T.reviewsUrl).then(function (r) { return r.json(); }).catch(function () { return REV; }),
    loadLiveRatings()
  ].concat(pages.map(function (u) { return fetch(u).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }); })))
    .then(function (res) {
      FIT = res[0] || {}; REV = res[1] || REV;
      REV.products = REV.products || {}; REV.store = REV.store || { avg: 0, n: 0 };
      mergeLive(res[2]);
      var raws = (res[3].products || []).concat(res[4].products || []);
      P = raws.map(decorate);
      P.forEach(function (p, k) {
        p.k = k; byHandle[p.h] = p;
        var r = REV.products[p.h];
        p.rank = (p.hot ? 0 : 1000) + (r ? -r.n * 10 : 0) + (p.out ? 5000 : 0) + k;
        p.stock = !p.out && !p.pre;
      });
    });
}

/* ---------- cards ---------- */
function rateBtn(p) {
  var r = REV.products[p.h];
  if (!r) return '<button class="crate none" type="button" data-r="' + p.k + '" aria-label="No reviews yet for this part">' + starSpan(0) + 'No reviews yet</button>';
  return '<button class="crate" type="button" data-r="' + p.k + '" aria-label="Rated ' + r.avg + ' out of 5 from ' + r.n + ' reviews">' + starSpan(r.avg) + (+r.avg).toFixed(1) + ' <span>(' + r.n + ')</span></button>';
}
function needsPick(p) { return p.variants.length > 1 || (p.b.length > 1 && !(sel && p.b.indexOf(sel) >= 0)); }
function fitFor(p) { return sel && p.b.indexOf(sel) >= 0 ? sel : (p.b[0] || null); }
/* Backdrop colour sampled from each product photo, so panels never box a shot in. */
var PBG = {};
if (window.THEME_PBG) {
  fetch(window.THEME_PBG).then(function (r) { return r.json(); })
    .then(function (m) { PBG = m; if ($('grid')) render(); }).catch(function () {});
}
function cardHTML(p) {
  var flags = [];
  if (p.out) flags.push('<span class="flag out">Sold out</span>');
  else if (p.pre) flags.push('<span class="flag pre">Pre-order</span>');
  else {
    if (p.ship) flags.push('<span class="flag stock">Ships next day</span>');
    if (p.hot) flags.push('<span class="flag hot">Best seller</span>');
  }
  if (p.rim) flags.push('<span class="flag pre">Rims only · no tires</span>');
  if (p.was && !p.out) flags.push('<span class="flag">Save ' + Math.round((1 - p.p / p.was) * 100) + '%</span>');
  var order = sel && p.b.indexOf(sel) >= 0 ? [sel].concat(p.b.filter(function (x) { return x !== sel; })) : p.b;
  var fits = p.cat === 'bikes' ? 'Complete bike' : p.cat === 'merch' ? 'LbxRide merch' : !p.b.length ? 'Universal fit'
    : order.slice(0, 2).map(bikeName).join(' · ') + (p.b.length > 2 ? ' +' + (p.b.length - 2) : '');
  var im = p.images[0];
  var pc = PBG[p.h];
  return '<article class="card' + (p.out ? ' soldout' : '') + '" data-i="' + p.k + '">' +
    '<div class="shot"' + (pc ? ' style="--photo-bg:' + pc + '"' : '') + '><div class="flags">' + flags.join('') + '</div>' +
    '<div class="ghost">' + esc(p.n) + '</div>' +
    (im ? '<img src="' + esc(imgUrl(im.src, 480)) + '" alt="' + esc(p.n) + '" loading="lazy">' : '') +
    '</div><div class="cbody">' +
    '<p class="fit' + (p.b.length ? '' : ' uni') + '">' + fits + '</p>' +
    '<h3 class="cname"><button class="open" type="button" data-i="' + p.k + '">' + esc(p.n) + '</button></h3>' +
    rateBtn(p) +
    '<div class="price"><span class="now">' + (p.vary ? 'From ' : '') + money(p.p) + '</span>' +
    (p.was && !p.out ? '<span class="was">' + money(p.was) + '</span>' : '') +
    (p.out ? '' : '<button class="qadd" type="button" data-q="' + p.k + '">' + (needsPick(p) ? 'Options' : (p.pre ? 'Pre-order' : 'Add')) + '</button>') +
    '</div></div></article>';
}
function cardsHTML(items) {
  if (!grouped()) return items.map(cardHTML).join('');
  var h = '';
  items.forEach(function (p) {
    var g = groupOf(p);
    if (g !== lastG) { lastG = g; h += '<div class="ghead"><h3>' + GROUPS[GIDX[g]][1] + '</h3><span>' + gCount[g] + ' part' + (gCount[g] > 1 ? 's' : '') + '</span></div>'; }
    h += cardHTML(p);
  });
  return h;
}

/* ---------- catalog ---------- */
function filtered() {
  var list = P.filter(function (p) {
    return (!sel || p.b.indexOf(sel) >= 0 || (only.uni && !p.b.length && p.cat !== 'bikes' && p.cat !== 'merch' && p.cat !== 'frames')) &&
      (!fcount() || fcats[p.cat]) &&
      (!only.stock || p.stock) &&
      (!only.sale || (p.was && !p.out)) &&
      (!only.hot || p.hot) &&
      (!query || (p.n + ' ' + p.b.map(bikeName).join(' ') + ' ' + catName(p.cat)).toLowerCase().indexOf(query) >= 0);
  });
  var fitFirst = function (a, b) { return sel ? ((b.b.indexOf(sel) >= 0 ? 1 : 0) - (a.b.indexOf(sel) >= 0 ? 1 : 0)) : 0; };
  if (sortBy === 'lo') list.sort(function (a, b) { return a.p - b.p; });
  else if (sortBy === 'hi') list.sort(function (a, b) { return b.p - a.p; });
  else if (sortBy === 'disc') list.sort(function (a, b) { return (b.was && !b.out ? 1 - b.p / b.was : 0) - (a.was && !a.out ? 1 - a.p / a.was : 0); });
  else if (sortBy === 'rated') list.sort(function (a, b) { var ra = REV.products[a.h], rb = REV.products[b.h]; return ((rb ? rb.n : 0) - (ra ? ra.n : 0)) || a.rank - b.rank; });
  else if (grouped()) list.sort(function (a, b) { return (GIDX[groupOf(a)] - GIDX[groupOf(b)]) || ((a.out ? 1 : 0) - (b.out ? 1 : 0)) || fitFirst(a, b) || a.rank - b.rank; });
  else list.sort(function (a, b) { return fitFirst(a, b) || a.rank - b.rank; });
  return list;
}
function render() {
  if (!$('grid')) return;
  current = filtered(); shown = Math.min(PAGE, current.length);
  lastG = null; gCount = {};
  current.forEach(function (p) { var g = groupOf(p); gCount[g] = (gCount[g] || 0) + 1; });
  $('ct').textContent = current.length;
  $('ctsuffix').textContent = sel ? 'for the ' + bikeName(sel) : (fcount() === 1 ? 'in ' + catName(Object.keys(fcats).filter(function (k) { return fcats[k]; })[0]) : '');
  $('empty').hidden = current.length > 0;
  $('grid').innerHTML = cardsHTML(current.slice(0, shown));
  drawMore();
}
function drawMore() {
  var left = current.length - shown;
  $('morewrap').hidden = left <= 0;
  $('moreinfo').textContent = 'Showing ' + shown + ' of ' + current.length;
  $('morebtn').textContent = 'Show ' + Math.min(PAGE, left) + ' more';
  $('morebar').style.width = (current.length ? shown / current.length * 100 : 0) + '%';
}
function goCatalog() {
  var cat = $('catalog'); if (!cat) return;
  var hdr = document.querySelector('header').getBoundingClientRect().height;
  var top = Math.max(0, cat.getBoundingClientRect().top + window.pageYOffset - hdr - 8);
  try { window.scrollTo({ top: top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  catch (e) { window.scrollTo(0, top); }
  clearTimeout(goCatalog.t);
  goCatalog.t = setTimeout(function () { if (Math.abs(window.pageYOffset - top) > 30) window.scrollTo(0, top); }, 900);
}

/* ---------- bike chips + facets ---------- */
var moreOpen = false;
function bikeCount(id) { return P.filter(function (p) { return p.b.indexOf(id) >= 0; }).length; }
function drawChips() {
  var wrap = $('bikechips'); if (!wrap) return;
  var order = BIKES.slice().sort(function (a, b) { return bikeCount(b.id) - bikeCount(a.id); });
  var list = moreOpen ? order : order.slice(0, 9);
  if (sel && !list.some(function (b) { return b.id === sel; })) list = list.concat(order.filter(function (b) { return b.id === sel; }));
  wrap.innerHTML = list.map(function (b) {
    return '<button class="chip" type="button" data-id="' + b.id + '" aria-pressed="' + (b.id === sel) + '">' + b.label + '<span class="n">' + bikeCount(b.id) + '</span></button>';
  }).join('') + '<button class="chip more" type="button" id="morechips">' + (moreOpen ? 'Fewer bikes' : '+' + (order.length - 9) + ' more bikes') + '</button>';
}
function syncChips() {
  drawChips();
  if (!$('fitline')) return;
  var nUni = P.filter(function (p) { return !p.b.length; }).length;
  $('clearbike').hidden = !sel;
  $('fitline').textContent = sel
    ? bikeCount(sel) + ' parts made for the ' + bikeName(sel) + (only.uni ? ', plus ' + nUni + ' universal parts.' : '.')
    : P.length + ' parts across ' + BIKES.length + ' bike models.';
  if ($('crumb')) $('crumb').textContent = sel ? bikeName(sel) : 'All models';
  if ($('unifacet')) $('unifacet').hidden = !sel;
}
function drawCatFacet() {
  if (!$('catfacet')) return;
  $('catfacet').innerHTML = CATS.map(function (c) {
    return '<label><input type="checkbox" value="' + c.id + '"' + (fcats[c.id] ? ' checked' : '') + '> ' + c.label +
      ' <span class="ct">' + P.filter(function (p) { return p.cat === c.id; }).length + '</span></label>';
  }).join('');
}
function syncNav() {
  document.querySelectorAll('nav.cats [data-cat]').forEach(function (a) {
    var on = a.dataset.cat === 'sale' ? (only.sale && !fcount()) : (fcount() === 1 && fcats[a.dataset.cat]);
    a.setAttribute('aria-current', on ? 'true' : 'false');
  });
}
function pickCategory(c) {
  fcats = {}; only.sale = false; only.hot = false;
  if (c === 'sale') only.sale = true;
  else if (c !== 'all') fcats[c] = true;
  if ($('onsale')) $('onsale').checked = only.sale;
  if ($('bestsel')) $('bestsel').checked = false;
  drawCatFacet(); syncNav(); render(); goCatalog();
}

/* ---------- product view ---------- */
var cur = null, pq = 1, pbike = null, gi = 0, pvariant = null;
var pdlg = $('pdlg'), cdlg = $('cdlg'), rdlg = $('rdlg');
function show(d) { if (d && !d.open) { d.showModal(); d.dataset.openedAt = Date.now(); document.body.classList.add('locked'); } }
function anyOpen() { return (pdlg && pdlg.open) || (cdlg && cdlg.open) || (rdlg && rdlg.open); }

function galleryHTML(p) {
  var g = p.images, n = g.length;
  if (!n) return '<div class="gal"><div class="gframe"><div class="ghost">' + esc(p.n) + '</div></div></div>';
  return '<div class="gal" role="region" aria-roledescription="carousel" aria-label="Product photos">' +
    '<div class="gframe" id="gframe"' + (PBG[p.h] ? ' style="--photo-bg:' + PBG[p.h] + '"' : '') + '><img id="gimg" src="' + esc(imgUrl(g[gi].src, 1000)) + '" alt="' + esc(p.n) + ' — photo ' + (gi + 1) + ' of ' + n + '">' +
    (n > 1 ? '<button type="button" class="garrow prev" id="gprev" aria-label="Previous photo"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="garrow next" id="gnext" aria-label="Next photo"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<span class="gcount" id="gcount">' + (gi + 1) + ' / ' + n + '</span>' : '') +
    '</div>' +
    (n > 1 ? '<div class="gthumbs" id="gthumbs">' + g.map(function (im, j) {
      return '<button type="button" data-g="' + j + '" aria-label="Show photo ' + (j + 1) + '"' + (j === gi ? ' aria-current="true"' : '') +
        '><img src="' + esc(imgUrl(im.src, 160)) + '" alt="" loading="lazy"></button>';
    }).join('') + '</div>' : '') + '</div>';
}
function showG(j) {
  var p = P[cur], n = p.images.length; if (n < 2) return;
  gi = (j + n) % n;
  var im = $('gimg'); im.src = imgUrl(p.images[gi].src, 1000); im.alt = p.n + ' — photo ' + (gi + 1) + ' of ' + n;
  $('gcount').textContent = (gi + 1) + ' / ' + n;
  Array.prototype.forEach.call($('gthumbs').children, function (b, k) {
    if (k === gi) { b.setAttribute('aria-current', 'true'); b.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
    else b.removeAttribute('aria-current');
  });
}
function variantFor(p, choice) {
  return p.variants.filter(function (v) { return v.available || true; }).find(function (v) {
    return [v.option1, v.option2, v.option3].slice(0, p.options.length).every(function (o, i) { return !choice[i] || o === choice[i]; });
  }) || p.variants[0];
}
function drawSheet() {
  var p = P[cur];
  var r = REV.products[p.h];
  var v = pvariant || p.variants[0];
  var price = Math.round(parseFloat(v.price) * 100), cmp = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
  var save = cmp > price ? Math.round((1 - price / cmp) * 100) : 0;
  var st = !v.available ? ['out', 'Sold out. Message us for restock timing.']
    : p.pre ? ['pre', 'Pre-order. Ships as soon as the next batch lands in California.']
      : p.ship ? ['', 'In stock. Ships next business day from California.'] : ['', 'In stock.'];
  var opts = p.options.length && !(p.options.length === 1 && p.options[0].name === 'Title')
    ? p.options.map(function (o, oi) {
      var vals = []; p.variants.forEach(function (vv) { var val = [vv.option1, vv.option2, vv.option3][oi]; if (val && vals.indexOf(val) < 0) vals.push(val); });
      return '<div><label class="lbl" for="opt' + oi + '">' + esc(o.name) + '</label><select class="fullsel popt" id="opt' + oi + '" data-oi="' + oi + '">' +
        vals.map(function (val) {
          // Label values that are sold out in every combination they appear in.
          var any = p.variants.some(function (vv) { return [vv.option1, vv.option2, vv.option3][oi] === val && vv.available; });
          return '<option value="' + esc(val) + '"' + (val === [v.option1, v.option2, v.option3][oi] ? ' selected' : '') + '>' +
            esc(val) + (any ? '' : ' — sold out') + '</option>';
        }).join('') + '</select></div>';
    }).join('') : '';
  var body = (p.body || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  var others = P.filter(function (o) {
    return o !== p && !o.out && o.cat !== 'merch' && o.cat !== 'bikes' && (pbike ? o.b.indexOf(pbike) >= 0 : o.cat !== p.cat && !o.b.length);
  }).sort(function (a, b) { return a.rank - b.rank; });
  others = others.filter(function (o) { return o.cat !== p.cat; }).concat(others.filter(function (o) { return o.cat === p.cat; })).slice(0, 3);

  $('pcrumbs').textContent = catName(p.cat) + ' · ' + (p.cat === 'bikes' ? 'Complete bike' : !p.b.length ? 'Universal fit' : p.b.length > 1 ? p.b.length + ' compatible models' : bikeName(p.b[0]));
  $('pbody').innerHTML =
    '<div class="psheet">' + galleryHTML(p) +
    '<div class="pinfo">' +
    '<h2 id="pname">' + esc(p.n) + '</h2>' +
    (r ? '<button class="prate" type="button" id="goRevs">' + starSpan(r.avg) + (+r.avg).toFixed(1) + ' <span>' + r.n + ' review' + (r.n > 1 ? 's' : '') + '</span></button>' : '') +
    '<div class="pprice"><span class="now">' + money(price) + '</span>' + (save ? '<span class="was">' + money(cmp) + '</span><span class="save">SAVE ' + save + '%</span>' : '') + '</div>' +
    '<div class="status ' + st[0] + '"><i></i><span>' + st[1] + '</span></div>' +
    (p.cat === 'bikes' || p.cat === 'merch' ? '' : '<div><p class="lbl">Fits</p><div class="fitlist">' +
      (p.b.length ? p.b.map(function (b) { return '<span class="fitchip on">✓ ' + bikeName(b) + '</span>'; }).join('')
        : '<span class="fitchip on">Universal — not model-specific</span>') +
      '</div>' + (sel && p.b.length && p.b.indexOf(sel) < 0 ? '<p class="fitwarn">Not listed for your ' + bikeName(sel) + '.</p>' : '') + '</div>') +
    (opts ? '<div class="optgrid">' + opts + '</div>' : '') +
    (p.b.length > 1 ? '<div><label class="lbl" for="pbike">Your bike</label><select class="fullsel" id="pbike">' +
      p.b.map(function (b) { return '<option value="' + b + '"' + (b === pbike ? ' selected' : '') + '>' + bikeName(b) + '</option>'; }).join('') + '</select></div>' : '') +
    '<div class="buyrow"><div class="qty">' +
    '<button type="button" id="pdec" aria-label="Decrease quantity"' + (pq <= 1 || !v.available ? ' disabled' : '') + '>&minus;</button>' +
    '<output id="pqty" aria-label="Quantity">' + pq + '</output>' +
    '<button type="button" id="pinc" aria-label="Increase quantity"' + (pq >= 9 || !v.available ? ' disabled' : '') + '>+</button></div>' +
    '<button class="btn" id="padd" type="button"' + (!v.available ? ' disabled' : '') + '>' + (!v.available ? 'Sold out' : (p.pre ? 'Pre-order' : 'Add to cart') + ' — ' + money(price * pq)) + '</button></div>' +
    '<ul class="specs">' +
    (/pre-?bled/i.test(p.n + ' ' + body) ? '<li>Arrives pre-bled — mount it and ride</li>' : '') +
    (p.ship ? '<li>Ships the next business day from California</li>' : '') +
    (p.b.length ? '<li>Listed for: ' + p.b.map(bikeName).join(', ') + '</li>' : '') +
    '</ul>' +
    (body ? '<div class="about"><p class="lbl">About this part</p><div class="abody" tabindex="0" role="region" aria-label="Product description">' + esc(body) + '</div></div>' : '') +
    '<p class="srcnote"><a href="' + ROOT + 'products/' + p.h + '">Open the full product page</a></p>' +
    '</div></div>' +
    reviewsBlock(p) +
    (others.length ? '<div class="pairs"><h3>' + (pbike ? 'Riders on the ' + bikeName(pbike) + ' also fit' : 'Pairs well with') + '</h3><div class="pairgrid">' +
      others.map(function (o) {
        return '<button class="pair" type="button" data-i="' + o.k + '"><span class="th">' + (o.images[0] ? '<img src="' + esc(imgUrl(o.images[0].src, 160)) + '" alt="">' : '') + '</span>' +
          '<span><b>' + esc(o.n) + '</b><span>' + (o.vary ? 'From ' : '') + money(o.p) + '</span></span></button>';
      }).join('') + '</div></div>' : '');

  wireGallery();
  var gr = $('goRevs'); if (gr) gr.onclick = function () { $('prevs').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
  var sb = $('pbike'); if (sb) sb.onchange = function (e) { pbike = e.target.value; drawSheet(); };
  Array.prototype.forEach.call($('pbody').querySelectorAll('.popt'), function (s) {
    s.onchange = function () {
      var choice = Array.prototype.map.call($('pbody').querySelectorAll('.popt'), function (x) { return x.value; });
      pvariant = variantFor(p, choice); drawSheet();
    };
  });
  $('pdec').onclick = function () { pq = Math.max(1, pq - 1); drawSheet(); $('pdec').focus(); };
  $('pinc').onclick = function () { pq = Math.min(9, pq + 1); drawSheet(); $('pinc').focus(); };
  $('padd').onclick = function () {
    var btn = $('padd'); btn.disabled = true; btn.textContent = 'Adding…';
    addToCart((pvariant || p.variants[0]).id, pq).then(function () { pdlg.close(); openCart(); });
  };
  Array.prototype.forEach.call($('pbody').querySelectorAll('.pair'), function (b) {
    b.onclick = function () { openProduct(+b.dataset.i, pbike); };
  });
}
function wireGallery() {
  var fr = $('gframe'); if (!fr) return;
  if ($('gprev')) {
    $('gprev').onclick = function () { showG(gi - 1); };
    $('gnext').onclick = function () { showG(gi + 1); };
    $('gthumbs').onclick = function (e) { var b = e.target.closest('[data-g]'); if (b) showG(+b.dataset.g); };
    var x0 = null;
    fr.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    fr.addEventListener('pointerup', function (e) { if (x0 == null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) showG(gi + (dx < 0 ? 1 : -1)); });
  }
}
function revItem(r, showProd) {
  var prod = showProd ? (r.h && byHandle[r.h] ? '<button type="button" class="rprod" data-i="' + byHandle[r.h].k + '">' + esc(byHandle[r.h].n) + '</button>' : '<span class="rprod">' + esc(r.pn || '') + '</span>') : '';
  return '<li class="rev"><div class="top">' + starSpan(r.s, true) + '<span>' + esc(r.a) + '</span>' + (r.v ? '<span class="vcheck">Verified</span>' : '') +
    (r.d ? '<time datetime="' + r.d + '">' + fmtDate(r.d) + '</time>' : '') + '</div><p>' + esc(r.b) + '</p>' + prod + '</li>';
}
function reviewsBlock(p) {
  var r = REV.products[p.h];
  var page = ROOT + 'products/' + p.h;
  var plural = function (n) { return n + ' review' + (n === 1 ? '' : 's'); };
  var head = '<div class="prevhead"><h3>Reviews</h3>' +
    (r ? starSpan(r.avg, true) + '<small>' + (+r.avg).toFixed(1) + ' from ' + plural(r.n) + '</small>' : '') +
    '<a class="wrbtn" href="' + page + '#write-review">Write a review</a></div>';
  var body;
  if (r && r.list.length) {
    body = '<ul class="revlist">' + r.list.map(function (x) { return revItem(x, false); }).join('') + '</ul>' +
      (r.list.length < r.n ? '<p class="srcnote" style="margin-top:10px"><a href="' + page + '#reviews">Read all ' + plural(r.n) + '</a></p>' : '');
  } else if (r) {
    body = '<div class="noreviews">Riders have rated this part ' + (+r.avg).toFixed(1) + ' out of 5. <a class="clearbtn" href="' + page + '#reviews">Read the ' + plural(r.n) + '</a></div>';
  } else {
    body = '<div class="noreviews"><b>No reviews on this part yet.</b> Bought it? <a class="clearbtn" href="' + page + '#write-review">Be the first to review it</a>. LbxRide averages ' +
      starSpan(REV.store.avg) + ' ' + REV.store.avg + ' across ' + REV.store.n + ' store reviews. <button type="button" class="clearbtn" data-allrev>Read them</button></div>';
  }
  return '<section class="prevs" id="prevs">' + head + body + '</section>';
}
function openProduct(i, bike, toReviews) {
  if (rdlg && rdlg.open) rdlg.close();
  cur = i; pq = 1; gi = 0; pvariant = null;
  var p = P[i];
  pbike = bike && p.b.indexOf(bike) >= 0 ? bike : fitFor(p);
  drawSheet(); show(pdlg); pdlg.scrollTop = 0;
  pdlg.querySelector('[data-close]').focus({ preventScroll: true });
  if (toReviews) requestAnimationFrame(function () { $('prevs').scrollIntoView({ block: 'start' }); });
}

/* ---------- cart (real Shopify cart) ---------- */
var FREE = 15000;
function setCart(c) { cart = c; renderCart(); }
function fetchCart() { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(setCart); }
function addToCart(id, qty) {
  return fetch(ROOT + 'cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
  }).then(function (r) { return r.json(); }).then(fetchCart).catch(function () { toast('Could not add that to the cart.'); });
}
function changeLine(line, qty) {
  return fetch(ROOT + 'cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  }).then(function (r) { return r.json(); }).then(setCart);
}
function renderCart() {
  var n = cart.item_count || 0, sub = cart.total_price || 0;
  var cc = $('cartcount');
  if (cc) { cc.textContent = n; cc.hidden = !n; }
  if ($('cartbtn')) $('cartbtn').setAttribute('aria-label', n ? 'Open cart, ' + n + ' item' + (n > 1 ? 's' : '') : 'Open cart, empty');
  if (!$('lines')) return;
  $('cqty').textContent = n ? n + ' item' + (n > 1 ? 's' : '') : '';
  var empty = !n;
  $('cempty').hidden = !empty; $('lines').hidden = empty; $('cfoot').hidden = empty; $('shipmeter').hidden = empty;
  var free = sub >= FREE;
  $('shipmeter').classList.toggle('done', free);
  $('shiptext').textContent = free ? 'Free US shipping unlocked.' : money(FREE - sub) + ' away from free US shipping.';
  $('shipbar').style.width = Math.min(100, sub / FREE * 100) + '%';
  $('csub').textContent = money(sub);
  $('ctotal').textContent = money(sub);
  $('lines').innerHTML = (cart.items || []).map(function (l, k) {
    return '<li class="line" data-k="' + (k + 1) + '">' +
      '<div class="lthumb">' + (l.image ? '<img src="' + esc(imgUrl(l.image, 160)) + '" alt="">' : '') + '</div>' +
      '<div><p class="lname"><a href="' + esc(l.url) + '">' + esc(l.product_title) + '</a></p>' +
      '<p class="lfit">' + (l.variant_title && l.variant_title !== 'Default Title' ? esc(l.variant_title) : '') + '</p>' +
      '<div class="lrow"><div class="qty">' +
      '<button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button>' +
      '<output aria-label="Quantity">' + l.quantity + '</output>' +
      '<button type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
      '</div><button type="button" class="lrm" data-act="rm">Remove</button></div></div>' +
      '<div class="lprice">' + money(l.line_price) + (l.quantity > 1 ? '<small>' + money(l.price) + ' each</small>' : '') + '</div></li>';
  }).join('');
}
function openCart() { hideToast(); show(cdlg); }

/* ---------- toast ---------- */
var tt, tHandle = null;
function toast(msg, withBtn) {
  if (!$('toast')) return;
  $('toastmsg').textContent = msg; $('toastbtn').hidden = !withBtn;
  $('toast').hidden = false; clearTimeout(tt); tt = setTimeout(hideToast, 4200);
}
function hideToast() { if ($('toast')) $('toast').hidden = true; }

/* ---------- hero ---------- */
function initHero() {
  var stage = $('stage'); if (!stage) return;
  var slides = Array.prototype.slice.call(stage.querySelectorAll('.slide'));
  if (slides.length < 2) return;
  var dots = $('dots'), si = 0, timer = null, paused = false;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 5500;
  stage.style.setProperty('--dur', DUR + 'ms');
  dots.innerHTML = slides.map(function (s, i) { return '<button type="button" class="dotbtn" aria-label="Show photo ' + (i + 1) + '"' + (i ? '' : ' aria-current="true"') + '><i></i></button>'; }).join('');
  function go(n) {
    si = (n + slides.length) % slides.length;
    slides.forEach(function (el, i) { el.classList.toggle('on', i === si); el.setAttribute('aria-hidden', i !== si); });
    Array.prototype.forEach.call(dots.children, function (d, i) { d.removeAttribute('aria-current'); if (i === si) { void d.offsetWidth; d.setAttribute('aria-current', 'true'); } });
    schedule();
  }
  function schedule() { clearTimeout(timer); if (!paused && !reduce) timer = setTimeout(function () { go(si + 1); }, DUR); }
  function setPaused(v) { paused = v; stage.classList.toggle('paused', v); if (v) clearTimeout(timer); else schedule(); }
  $('prev').onclick = function () { go(si - 1); };
  $('next').onclick = function () { go(si + 1); };
  dots.onclick = function (e) { var b = e.target.closest('.dotbtn'); if (b) go(Array.prototype.indexOf.call(dots.children, b)); };
  stage.addEventListener('mouseenter', function () { setPaused(true); });
  stage.addEventListener('mouseleave', function () { setPaused(false); });
  stage.addEventListener('focusin', function () { setPaused(true); });
  stage.addEventListener('focusout', function () { setPaused(false); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
  if (reduce) stage.classList.add('paused');
  schedule();
}

/* tiles with no photo chosen borrow the lead product photo of that category */
function fillTiles() {
  document.querySelectorAll('.tiles .ph[data-fill]').forEach(function (ph) {
    var cat = ph.dataset.fill;
    var lead = P.filter(function (p) { return (cat === 'hot' ? p.hot : p.cat === cat) && p.images.length && !p.out; })
      .sort(function (a, b) { return a.rank - b.rank; })[0];
    if (!lead) return;
    var im = new Image();
    im.src = imgUrl(lead.images[0].src, 500); im.alt = ''; im.loading = 'lazy';
    ph.appendChild(im);
  });
}

/* ---------- reviews ribbon ---------- */
function initReviews() {
  if (REV.store.n) {
    document.querySelectorAll('[data-storeavg]').forEach(function (e) { e.textContent = REV.store.avg; });
    document.querySelectorAll('.stars[data-store]').forEach(function (s) { s.style.setProperty('--pct', (REV.store.avg / 5 * 100) + '%'); });
    document.querySelectorAll('[data-storecount]').forEach(function (e) { e.textContent = REV.store.n; });
  }
  if (!$('rrow')) return;
  var feed = REV.feed || [];
  function card(r, dup) {
    var p = r.h && byHandle[r.h];
    var prod = p ? '<button type="button" class="rprod" data-rk="' + p.k + '"' + (dup ? ' tabindex="-1"' : '') + '>' + esc(p.n) + '</button>' : '<span class="rprod">' + esc(r.pn || '') + '</span>';
    return '<article class="rcard"' + (dup ? ' aria-hidden="true"' : '') + '>' + starSpan(r.s, !dup) + '<q>' + esc(r.b) + '</q>' +
      '<div class="rmeta">' + esc(r.a) + (r.v ? '<span class="vcheck">Verified</span>' : '') + '</div>' + prod + '</article>';
  }
  var rib = feed.slice(0, 16);
  $('rrow').innerHTML = rib.map(function (r) { return card(r, false); }).join('') + rib.map(function (r) { return card(r, true); }).join('');
  $('rrow').onclick = function (e) { var b = e.target.closest('[data-rk]'); if (b) openProduct(+b.dataset.rk, null, true); };
  if ($('allrevs')) {
    $('allrevs').innerHTML = feed.map(function (r) { return revItem(r, true); }).join('');
    $('allrevs').onclick = function (e) { var b = e.target.closest('[data-i]'); if (b) openProduct(+b.dataset.i, null, true); };
  }
}

/* ---------- wiring ---------- */
function wire() {
  if ($('bikechips')) {
    $('bikechips').onclick = function (e) {
      if (e.target.closest('#morechips')) { moreOpen = !moreOpen; drawChips(); return; }
      var c = e.target.closest('.chip'); if (!c) return;
      sel = sel === c.dataset.id ? null : c.dataset.id; syncChips(); render();
      if (sel) goCatalog();
    };
    $('clearbike').onclick = function () { sel = null; syncChips(); render(); };
  }
  if ($('catfacet')) {
    $('catfacet').onchange = function (e) { fcats[e.target.value] = e.target.checked; syncNav(); render(); };
    $('instock').onchange = function (e) { only.stock = e.target.checked; render(); };
    $('onsale').onchange = function (e) { only.sale = e.target.checked; syncNav(); render(); };
    $('bestsel').onchange = function (e) { only.hot = e.target.checked; render(); };
    $('inclu').onchange = function (e) { only.uni = e.target.checked; syncChips(); render(); };
    $('sort').onchange = function (e) { sortBy = e.target.value; render(); };
    $('filtbtn').onclick = function () {
      var open = $('rail').classList.toggle('shut') === false;
      $('filtbtn').setAttribute('aria-expanded', open);
      $('filtbtn').textContent = open ? 'Hide filters' : 'Filters';
    };
  }
  if ($('grid')) {
    function gridActivate(t) {
      var rb = t.closest('[data-r]');
      if (rb) { openProduct(+rb.dataset.r, null, true); return true; }
      var q = t.closest('[data-q]');
      if (q) {
        var p = P[+q.dataset.q];
        if (needsPick(p)) { openProduct(p.k); return true; }
        q.disabled = true; q.textContent = '…';
        addToCart(p.variants[0].id, 1).then(function () { q.disabled = false; q.textContent = 'Add'; toast((p.pre ? 'Pre-ordered: ' : 'Added: ') + p.n, true); });
        return true;
      }
      var o = t.closest('[data-i]'); if (o) { openProduct(+o.dataset.i); return true; }
      return false;
    }
    (function () {
      var g = $('grid'), sx = 0, sy = 0, st = 0;
      g.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; st = Date.now();
      }, { passive: true });
      g.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        if (Date.now() - st > 700) return;
        if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) return;
        if (gridActivate(e.target)) e.preventDefault();
      }, { passive: false });
      g.addEventListener('click', function (e) { gridActivate(e.target); });
    })();
    $('morebtn').onclick = function () {
      var next = current.slice(shown, shown + PAGE);
      $('grid').insertAdjacentHTML('beforeend', cardsHTML(next));
      shown += next.length; drawMore();
    };
  }
  window.addEventListener('touchmove', function () {
    var a = document.activeElement;
    if (a && a.tagName === 'INPUT' && a.type === 'search') a.blur();
  }, { passive: true });
  var sq = $('q');
  if (sq && $('grid')) {
    sq.addEventListener('input', function () { query = sq.value.trim().toLowerCase(); render(); });
    sq.form && sq.form.addEventListener('submit', function (e) { if (query) { e.preventDefault(); goCatalog(); } });
  }
  if ($('tiles')) {
    $('tiles').onclick = function (e) {
      var b = e.target.closest('[data-tile]'); if (!b) return;
      var c = b.dataset.tile;
      if (c === 'hot') { fcats = {}; only.hot = true; only.sale = false; if ($('bestsel')) $('bestsel').checked = true; drawCatFacet(); syncNav(); render(); goCatalog(); }
      else pickCategory(c);
    };
  }
  var nav = document.querySelector('nav.cats');
  if (nav) {
    nav.onclick = function (e) {
      var a = e.target.closest('[data-cat]'); if (!a) return;
      var strip = a.parentElement.parentElement;
      strip.scrollTo({ left: a.offsetLeft - strip.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
      if (!$('grid')) return;                 // other pages: follow the link to the collection
      e.preventDefault(); pickCategory(a.dataset.cat);
    };
  }
  [pdlg, cdlg, rdlg].forEach(function (d) {
    if (!d) return;
    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { d.close(); return; }
      // The tap that opens the sheet can land again on the backdrop and close it
      // instantly on touch devices. Ignore backdrop clicks from the opening gesture.
      if (e.target === d && Date.now() - (+d.dataset.openedAt || 0) > 500) d.close();
    });
    d.addEventListener('close', function () { if (!anyOpen()) document.body.classList.remove('locked'); });
  });
  if (pdlg) pdlg.addEventListener('keydown', function (e) {
    if (e.target.closest('select,input')) return;
    if (e.key === 'ArrowRight') { showG(gi + 1); e.preventDefault(); }
    if (e.key === 'ArrowLeft') { showG(gi - 1); e.preventDefault(); }
  });
  if ($('searchtoggle')) $('searchtoggle').onclick = function () {
    var row = $('searchrow'), open = row.hidden;
    row.hidden = !open;
    $('searchtoggle').setAttribute('aria-expanded', open);
    if (open) $('q-mobile').focus();
  };
  // The phone field was never wired to the catalog filter — only the desktop one was.
  // Type to filter, Enter or the magnifier to jump to the results.
  var qm = $('q-mobile');
  if (qm && $('grid')) {
    qm.setAttribute('enterkeyhint', 'search');
    qm.addEventListener('input', function () {
      query = qm.value.trim().toLowerCase();
      if (sq && sq.value !== qm.value) sq.value = qm.value;   // keep both fields in step
      render();
    });
    qm.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && query) { e.preventDefault(); qm.blur(); goCatalog(); }
    });
    if (qm.form) qm.form.addEventListener('submit', function (e) {
      if (query) { e.preventDefault(); qm.blur(); goCatalog(); }   // empty box falls through to Shopify search
    });
  }
  if ($('cartbtn')) $('cartbtn').onclick = openCart;
  if ($('lines')) $('lines').onclick = function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var li = b.closest('.line'), line = +li.dataset.k, item = cart.items[line - 1], act = b.dataset.act;
    if (act === 'inc') changeLine(line, item.quantity + 1);
    else if (act === 'dec') changeLine(line, item.quantity - 1);
    else if (act === 'rm') changeLine(line, 0);
  };
  if ($('checkout')) $('checkout').onclick = function () { window.location.href = ROOT + 'checkout'; };
  if ($('toastbtn')) $('toastbtn').onclick = function () { openCart(); };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-allrev]')) { if (pdlg && pdlg.open) pdlg.close(); show(rdlg); if (rdlg) rdlg.scrollTop = 0; }
  });
  wireCopyLink();
}

/* ---------- copy link to a single product (deep links for marketing) ---------- */
function productURL(p) {
  return location.origin + ROOT + 'products/' + encodeURIComponent(p.h);
}
function legacyCopy(txt, btn) {
  // Inside a <dialog> the helper field has to live in the dialog to be selectable.
  var host = btn.closest('dialog') || document.body, ta = document.createElement('textarea');
  ta.value = txt; ta.setAttribute('readonly', '');
  ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
  host.appendChild(ta); ta.select(); ta.setSelectionRange(0, txt.length);
  var ok = false;
  try { ok = document.execCommand('copy'); } catch (err) {}
  ta.remove();
  return ok;
}
function copyText(txt, btn) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(txt).then(function () { return true; },
      function () { return legacyCopy(txt, btn); });
  }
  return Promise.resolve(legacyCopy(txt, btn));
}
function wireCopyLink() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copylink]');
    if (!btn) return;
    e.preventDefault();
    // Product page carries its own URL; the sheet button reads whichever product is open.
    var url = btn.dataset.url || (cur != null && P[cur] ? productURL(P[cur]) : '');
    if (!url) return;
    if (!btn.dataset.label) btn.dataset.label = btn.getAttribute('aria-label') || 'Copy link';
    copyText(url, btn).then(function (ok) {
      if (!ok) { window.prompt('Copy this link:', url); return; }
      btn.classList.add('ok');
      btn.setAttribute('aria-label', 'Link copied');
      clearTimeout(btn.copyT);
      btn.copyT = setTimeout(function () {
        btn.classList.remove('ok');
        btn.setAttribute('aria-label', btn.dataset.label);
      }, 1800);
      toast('Link copied — ' + url.replace(/^https?:\/\//, ''), false);
    });
  });
}

function start() {
  initHero();
  wire();
  fetchCart();
  if (!$('grid')) return;                     // catalog only renders where the section is on the page
  $('loadstate').hidden = false;
  load().then(function () {
    $('loadstate').hidden = true;
    if ($('instockct')) {
      $('instockct').textContent = P.filter(function (p) { return p.stock; }).length;
      $('onsalect').textContent = P.filter(function (p) { return p.was && !p.out; }).length;
      $('bestselct').textContent = P.filter(function (p) { return p.hot; }).length;
      $('inclu-ct').textContent = P.filter(function (p) { return !p.b.length; }).length;
    }
    if ($('tilecount')) $('tilecount').textContent = CATS.length + ' categories · ' + P.length + ' parts';
    fillTiles();
    drawCatFacet(); syncChips(); syncNav(); initReviews();
    var params = new URLSearchParams(location.search);
    var c = params.get('cat'); var bike = params.get('bike');
    if (bike) sel = bike;
    if (c) { if (c === 'sale') only.sale = true; else if (c === 'hot') { only.hot = true; if ($('bestsel')) $('bestsel').checked = true; } else fcats[c] = true; if ($('onsale')) $('onsale').checked = only.sale; drawCatFacet(); }
    syncChips(); syncNav(); render();
    if (c || bike) goCatalog();
    // Deep link into the sheet: /?product=<handle>. A bare /products/<handle>
    // link is served by Shopify itself and needs nothing here.
    var ph = params.get('product');
    if (ph && byHandle[ph]) openProduct(byHandle[ph].k);
  }).catch(function () {
    $('loadstate').textContent = 'Could not load the catalog. Reload the page to try again.';
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
